import { coreApiAuthedClient } from '@/src/shared/api/clients';
import { toApiError } from '@/src/shared/api/accounts/http';
import type { HouseholdCategoryLink } from './dto';

const BASE = '/v1/households/me/category-links';

export async function getCategoryLinks(): Promise<HouseholdCategoryLink[]> {
  try {
    const res = await coreApiAuthedClient.GET<unknown, { items: HouseholdCategoryLink[] }>({
      path: BASE,
    });
    return res.data.items;
  } catch (err) {
    toApiError(err);
  }
}

export async function linkCategory(categoryId: string, householdCategoryId: string): Promise<void> {
  try {
    await coreApiAuthedClient.PUT<{ household_category_id: string }, unknown>({
      path: `${BASE}/${encodeURIComponent(categoryId)}`,
      data: { household_category_id: householdCategoryId },
    });
  } catch (err) {
    toApiError(err);
  }
}

export async function unlinkCategory(categoryId: string): Promise<void> {
  try {
    await coreApiAuthedClient.DELETE({ path: `${BASE}/${encodeURIComponent(categoryId)}` });
  } catch (err) {
    toApiError(err);
  }
}
